module.exports = __webpack_public_path__ + "html/update-banner.template.html";